import { Component, OnInit, ViewEncapsulation, ViewChild, Input } from '@angular/core';

import { Router } from '@angular/router';
import { DialogService, NotificationService, TranslationService } from '../../shared/index';
import { NavigationService } from '../../shared/navigation/navigation.service';

import { DashboardService } from '../../dashboard/shared/dashboard.service';
import { MembershipActivityRow } from '../../dashboard/shared/membership-activity-row.model';
import { DashboardNeoRetentionComponent } from './dashboard-neo-retention.component';
import { MenuItem } from 'primeng/api';
import { DashboardNeoRetentionDonutComponent } from './dashboard-neo-retention-donut.component';
import { DashboardNeoRetentionMonthlyComponent } from './dashboard-neo-retention-monthly.component';

@Component({
  selector: 'wl-dashboard-neo-membership-activity',
  templateUrl: 'dashboard-neo-membership-activity.component.html',
  providers: [DashboardService],
  styleUrls: ['dashboard-neo-membership-activity.component.less'],
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DashboardNeoMembershipActivityComponent implements OnInit {
  private _router: Router;
  private _notificationService: NotificationService;
  private _dialogService: DialogService;
  private _navigationService: NavigationService;
  private _dashboardService: DashboardService;

  public showMembershipActivityDetails: boolean;
  public membershipActivityDetails: Array<MembershipActivityRow>;
  public membershipActivityTotals: MembershipActivityRow;
  public isLoading: boolean;
  public engagementReportsItems: MenuItem[];
  public selectedEngagementReport: MenuItem;
  public memberReportsItems: MenuItem[];

  public showContextBusyIndicator: boolean;

  @Input() hideSalesOpps: boolean;
  @Input() hideTasks: boolean;
  @Input() hideRetention: boolean = false;

  private _startDate: Date;
  @Input() public get startDate() {
    return this._startDate;
  }
  public set startDate(value: Date) {
    this._startDate = value;
    this.selectedDateChange();
  }

  private _endDate: Date;
  @Input() public get endDate() {
    return this._endDate;
  }
  public set endDate(value: Date) {
    this._endDate = value;
    this.selectedDateChange();
  }

  @ViewChild('retentionReport', { static: true }) retentionComponent: DashboardNeoRetentionComponent;
  @ViewChild('retentionDonut', { static: true }) retentionDonut: DashboardNeoRetentionDonutComponent;
  @ViewChild('addDropChart', { static: true }) addDropChart: DashboardNeoRetentionMonthlyComponent;

  public constructor(
    router: Router,
    notificationService: NotificationService,
    dialogService: DialogService,
    navigationService: NavigationService,
    dashboardService: DashboardService,
    private _translationService: TranslationService
  ) {
    this._router = router;
    this._notificationService = notificationService;
    this._dialogService = dialogService;
    this._navigationService = navigationService;
    this._dashboardService = dashboardService;

    this.isLoading = true;
    this.membershipActivityDetails = new Array<MembershipActivityRow>();
    this.membershipActivityTotals = new MembershipActivityRow();
  }

  ngOnInit() {
    this.showContextBusyIndicator = false;
    this.showMembershipActivityDetails = false;

    this.startDate = new Date(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();

    this.getMembershipActivityReport();
    this.retentionComponent.getRetentionReport();
  }

  public renewalStatistics2021Clicked() {
    this._navigationService.navigateRenwalStatisticsReport();
  }

  public toggleMembershipActivityDetails(): void {
    this.showMembershipActivityDetails = !this.showMembershipActivityDetails;
  }

  public selectedDateChange(): void {
    if (this.retentionComponent) {
      this.retentionComponent.startDate = this.startDate;
      this.retentionComponent.endDate = this.endDate;
      this.retentionComponent.getRetentionReport();
    }

    if (this.retentionDonut) {
      this.retentionDonut.startDate = this.startDate;
      this.retentionDonut.endDate = this.endDate;
      this.retentionDonut.getRetentionReport();
    }

    if (this.addDropChart) {
      this.addDropChart.startDate = this.startDate;
      this.addDropChart.endDate = this.endDate;
      this.addDropChart.getMonthlyAddDropReport();
    }

    this.getMembershipActivityReport();
  }

  public getMembershipActivityReport() {
    this._dashboardService.getMembershipActivityReport(this.startDate, this.endDate).then((data: Array<MembershipActivityRow>) => {
      this.membershipActivityDetails = data;

      this.calculateMembershipActivityTotals();
      this.isLoading = false;
    });
  }

  private calculateMembershipActivityTotals(): void {
    this.membershipActivityTotals = new MembershipActivityRow();

    let newMembers: number = this.membershipActivityDetails.reduce((newMembers, current) => newMembers + current.NewMembers, 0);
    this.membershipActivityTotals.NewMembers = newMembers;

    let newInvestment: number = this.membershipActivityDetails.reduce((newInvestment, current) => newInvestment + current.NewInvestment, 0);
    this.membershipActivityTotals.NewInvestment = newInvestment;

    let droppedMembers: number = this.membershipActivityDetails.reduce(
      (droppedMembers, current) => droppedMembers + current.DroppedMembers,
      0
    );
    this.membershipActivityTotals.DroppedMembers = droppedMembers;

    let lostInvestment: number = this.membershipActivityDetails.reduce(
      (lostInvestment, current) => lostInvestment + current.LostInvestment,
      0
    );
    this.membershipActivityTotals.LostInvestment = lostInvestment;

    let gainLoss: number = this.membershipActivityDetails.reduce((gainLoss, current) => gainLoss + current.GainLoss, 0);
    this.membershipActivityTotals.GainLoss = gainLoss;

    let gainLossInvestment: number = this.membershipActivityDetails.reduce(
      (gainLossInvestment, current) => gainLossInvestment + current.GainLossInvestment,
      0
    );
    this.membershipActivityTotals.GainLossInvestment = gainLossInvestment;

    let totalMembers: number = this.membershipActivityDetails.reduce((totalMembers, current) => totalMembers + current.TotalMembers, 0);
    this.membershipActivityTotals.TotalMembers = totalMembers;
  }
}
